import { formatNumToStandardNotation } from '@modules/common/utils';
import { QuantifyFormulaDefinition } from '@modules/quantify/components/AggregateFormulaResultTable/QuantifyFormulaDefinition';
import { ShowFeedbackDrawerFromTableOptions } from '@modules/quantify/components/QuantifyReportTableWidget/types';
import { Link, Tooltip } from '@mui/material';
import {
  IntermediateCsatFuncValue,
  IntermediateMeanFuncValue,
  IntermediateNpsFuncValue,
} from 'generated/graphql';
import { TimeRange } from 'v2/core/entities';

interface AggregateFormulaValueParams {
  value: number;
  nps?: IntermediateNpsFuncValue;
  csat?: IntermediateCsatFuncValue;
  mean?: IntermediateMeanFuncValue;
  dateRange?: TimeRange;
  onFeedbackCountClick: (params: ShowFeedbackDrawerFromTableOptions) => void;
}

export function AggregateFormulaValue({
  value,
  nps,
  csat,
  mean,
  dateRange,
  onFeedbackCountClick,
}: AggregateFormulaValueParams) {
  if (!value) {
    return <>{value}</>;
  }

  const title = (
    <QuantifyFormulaDefinition
      value={value}
      nps={nps}
      csat={csat}
      mean={mean}
    />
  );

  return (
    <>
      <Tooltip
        arrow
        title={title}
        placement="top"
        disableInteractive
        open={title ? undefined : false}
      >
        <Link
          component="button"
          variant="body1"
          onClick={(event) => {
            event.stopPropagation();

            onFeedbackCountClick({
              id: '',
              label: '',
              category: undefined,
              dateRange,
              isInvisible: false,
              isUpdateInProgress: false,
            });
          }}
          color="primary"
          underline="hover"
        >
          {formatNumToStandardNotation(value)}
        </Link>
      </Tooltip>
    </>
  );
}
